export class NETSTAT {
  Type: string = "NETSTAT";
  SerialNumber: string;
  NetData: any;
  Date: Date;
  networks: {
    eth0: string;
    eth1: string;
    wlan0: string;
    wwan0: string;
  };
}